import React from "react";

export default function SQLServer_LTRIM() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_LTRIM</h1>
      <p>This is the SQLServer_LTRIM component generated from the SQL JSON.</p>
    </div>
  );
}
